import { z } from "zod";
import { ProductState } from "@/core/products/components/ProductsTable";

export const createProductKitSchema = z.object({
  name: z.string().min(1, "El nombre del kit de producto es requerido"),
  products: z.custom<ProductState[]>(),
  enabled: z.boolean(),
  storageId: z.string().min(1, "La bodega es requerida"),
});

export type CreateProductKitInput = z.infer<typeof createProductKitSchema>;
